var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8382_28767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6838 11.6348C18.6838 11.8042 18.5881 11.9736 18.396 12.1029L11.1853 16.955C10.8018 17.2136 10.179 17.2136 9.79485 16.955L2.58354 12.1029C2.19937 11.8444 2.19937 11.4257 2.58354 11.1672C2.96705 10.9087 3.58984 10.9087 3.97401 11.1672L10.4898 15.5513L17.0049 11.1672C17.389 10.9087 18.0112 10.9087 18.3953 11.1672C18.5881 11.296 18.6838 11.4654 18.6838 11.6348Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8382_28767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6838 5.64263C18.6838 5.81203 18.5881 5.98143 18.396 6.11068L11.1853 10.9629C10.8018 11.2214 10.179 11.2214 9.79485 10.9629L2.58354 6.11068C2.19937 5.85217 2.19937 5.43352 2.58354 5.17501C2.96705 4.9165 3.58984 4.9165 3.97401 5.17501L10.4898 9.55913L17.0049 5.17501C17.389 4.9165 18.0112 4.9165 18.3953 5.17501C18.5881 5.30383 18.6838 5.47323 18.6838 5.64263Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8382_28767"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.8984L6.31526e-07 16.7817C1.47876e-06 11.2589 4.47716 6.78175 10 6.78175L10.9784 6.78175C16.5012 6.78175 20.9784 11.2589 20.9784 16.7817L20.9784 20.8984L0 20.8984Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8382_28767"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9062L6.31526e-07 10.7896C1.47876e-06 5.26671 4.47716 0.789558 10 0.789558L10.9784 0.789559C16.5012 0.789559 20.9784 5.26671 20.9784 10.7896L20.9784 14.9063L0 14.9062Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.fad97dcc6b1b90b20e307a257ca5e879.svg";
export { ForwardRef as ReactComponent };